import { resolveValue, formatValue, resolveColumnRef } from '../utils/chartDataUtils'

export default function Table({ data, chartOptions = {}, dimensionInfo = {} }) {
  if (!data || data.length === 0) {
    return <div className="text-center text-gray-500">No data available</div>;
  }

  // Helper to resolve and format a value from row
  const getValue = (row, column) => {
    const value = resolveValue(row, column, dimensionInfo)
    return formatValue(value, column)
  }

  // Use custom columns if provided, otherwise auto-generate
  // Columns can be full definitions or references to be resolved
  const columnDefs = chartOptions.columns || []
  const columns = columnDefs.length > 0
    ? columnDefs.map(col => {
        const resolved = resolveColumnRef(col, columnDefs)
        return {
          id: resolved.id,
          source: resolved.source,
          label: resolved.label || resolved.id || resolved.source,
          kind: resolved.kind,
          format: resolved.format,
          dateFormat: resolved.dateFormat,
          decimalPlaces: resolved.decimalPlaces
        }
      })
    : Object.keys(data[0]).map(key => ({
        source: key,
        label: key
      }))

  return (
    <div>
      <table className="flat-table">
        <thead>
          <tr>
            {columns.map((column, colIndex) => (
              <th key={typeof column.source === 'function' ? column.label || colIndex : column.source}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              {columns.map((column, colIndex) => (
                <td key={typeof column.source === 'function' ? column.label || colIndex : column.source}>
                  {getValue(row, column)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
